import TIK from 'constants/time/timeIntervalKind.const';
import logger from 'utils/logger.util';
import isNotEnumVal from 'utils/predicates/enum/isNotEnumVal.util';
import isNotDateWorthy from 'utils/predicates/time/isNotDateWorthy.util';

const L = logger('isOkRange'); // eslint-disable-line no-unused-vars

const isOkRange = (range) => {
  if (!range) return false;

  if (isNotEnumVal(TIK, range.kind)) return false;

  if (isNotDateWorthy(range.bgnTimestamp)) return false;
  if (isNotDateWorthy(range.endTimestamp)) return false;

  // noinspection RedundantIfStatementJS
  if (isNotDateWorthy(range?.raw)) return false;

  return true;
};

export default isOkRange;
